export enum ESerialActionType {
  RECEIVE = 'receive',
  SHIP = 'ship',
  SELL = 'sell',
  SEND = 'send',
  CANCEL = 'cancel',
}
